import { render, staticRenderFns } from "./CotizacionDetail.vue?vue&type=template&id=6e30875a&scoped=true"
import script from "./CotizacionDetail.vue?vue&type=script&lang=js"
export * from "./CotizacionDetail.vue?vue&type=script&lang=js"
import style0 from "./CotizacionDetail.vue?vue&type=style&index=0&id=6e30875a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e30875a",
  null
  
)

export default component.exports